import { gql } from '@apollo/client';

export const ORDERS_QUERY = gql`
  query OrdersQuery {
    orders {
      id
      paymentIntentId
      paymentMethod {
        brand
        last4
        id
      }
      amount
      audienceName
      recordsIncluded
      createdDate
      orderType
      seedFileId
      seedFileName
      packageName
      packageId
      packageReportReady
      # Three-state: 'generating' | 'ready' | 'failed'. packageReportReady
      # can't tell the last two apart, which left failed reports spinning.
      packageReportStatus
      audienceId
      audienceCrawlFailed
    }
  }
`;

export const ORDER_QUERY = gql`
  query OrderQuery($orderId: ID!, $expandInvoice: Boolean) {
    order(orderId: $orderId, expandInvoice: $expandInvoice) {
      id
      status
      promoCode
      invoiceId
      invoice {
        id
        lineItems {
          id
          priceId
          quantity
          amount
          discount
          productName
        }
        total
        discount {
          name
          amount
        }
      }
      paymentIntentId
      paymentMethod {
        brand
        last4
        id
      }
      products {
        id
        priceId
        price
        quantity
      }
      amount
      audienceName
      recordsIncluded
      createdDate
      orderType
      seedFileId
      seedFileName
      packageName
      packageId
    }
  }
`;

export const CUSTOMER_QUERY = gql`
  query CustomerQuery {
    customer {
      balance
      paymentMethods {
        id
        billing_details {
          address {
            city
            country
            line1
            line2
            postal_code
            state
          }
          email
          name
          phone
        }
        card {
          brand
          country
          exp_month
          exp_year
          last4
          isDefault
        }
        created
      }
    }
  }
`;

export const INVOICE_RECEIPT_URL = gql`
  query InvoiceReceiptUrl($invoiceId: String!) {
    invoiceReceiptUrl(invoiceId: $invoiceId)
  }
`;

export const PURCHASED_ENHANCEMENT_QUERY = gql`
  query PurchasedEnhancementQuery($packageId: String!) {
    purchasedEnhancement(packageId: $packageId) {
      downloadLink
    }
  }
`;

export const PURCHASED_INSIGHT_QUERY = gql`
  query PurchasedInsightQuery($packageId: String!) {
    purchasedInsight(packageId: $packageId) {
      downloadLink
    }
  }
`;
